<template>
    <div class="block">
        <el-popover placement="bottom-start" ref="popover" title="选择通道" width="600px" trigger="click">
            <template #reference>
                <el-button size="small">{{ nodeName }}</el-button>
            </template>
            <div style="width: 600px">
                <div style="padding: 10px">
                    <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                </div>
                <el-tree
                    class="my-tree"
                    ref="tree"
                    style="margin-top: 5px"
                    :data="dataList"
                    node-key="DoorID"
                    default-expand-all
                    highlight-current
                    :expand-on-click-node="false"
                    :filter-node-method="filterNode"
                    @node-click="handleNodeClick"
                >
                    <template #default="{ data }">
                        <div class="custom-tree-node">
                            <span class="menu-icon icon-door"></span>
                            <span>{{ data.DoorName }}</span>
                        </div>
                    </template>
                </el-tree>
            </div>
        </el-popover>
    </div>
</template>

<script>
export default {
    name: "SelectDoor",
    props: {
        entityID: { type: String },
    },
    data() {
        return {
            dataList: [],
            nodeName: "",
            dialogVisible: false,
            filterText: "",
            selectedModel: null,
        };
    },
    watch: {
        entityID(v) {
            if (v) {
                this.getAllDoors(v);
            }
        },
    },
    created() {},
    methods: {
        setSelectModel(e) {
            this.selectedModel = e;
            this.nodeName = this.selectedModel.DoorName;
            this.$emit("select", this.selectedModel);
        },
        getAllDoors(id) {
            this.$ajax.post("/Entity/GetEntityAllDoors?id=" + id).then((res) => {
                if (res.Data) {
                    this.dataList = [{ DoorID: "", DoorName: "全部通道" }, ...res.Data];
                } else {
                    this.dataList = [{ DoorID: "", DoorName: "全部通道" }];
                }
                this.setSelectModel(this.dataList[0]);
            });
        },
        filterNode(value, data) {
            if (!value) return true;
            console.log(data);
            return data.EntityName.includes(value);
        },
        handleNodeClick(data) {
            this.$refs.popover.hide();
            this.setSelectModel(data);
        },
    },
};
</script>
